import { call, put, all, spawn, takeEvery } from 'redux-saga/effects';

import request from '../../utils/request';
import {
  GET_TRANSACTION_COMPLETE_TIME,
  GET_TRANSACTION_COMPLETE_TIME_URL,
  SET_TRANSACTION_COMPLETE_TIME,
  SET_TRANSACTION_COMPLETE_TIME_URL,
} from './constants';

import { showToast } from '../Toast/actions';

import { disableLoaderAction } from './actions';

export function* setTransactionCompleteTime({ data }: any) {
  try {
    const {
      data: { merchantId, transactionCompletionTimeMins },
      cb,
    } = data;
    const { url, method } = SET_TRANSACTION_COMPLETE_TIME_URL;
    const updatedUrl = url.replace('$merchantId$', merchantId);

    const bodyParams = {
      config_key: 'TTL',
      config_value: transactionCompletionTimeMins,
      reason: 'TTL change',
    };
    const options = {
      method,
      body: JSON.stringify(bodyParams),
    };
    const response = yield call(request, updatedUrl, options);
    cb(response);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* setTransactionCompleteTimeSaga() {
  yield takeEvery(SET_TRANSACTION_COMPLETE_TIME, setTransactionCompleteTime);
}

export function* getTransactionCompleteTime({ data }: any) {
  try {
    const { merchantId, cb } = data;
    const { url, method } = GET_TRANSACTION_COMPLETE_TIME_URL;
    const updatedUrl = url.replace('$merchantId$', merchantId);

    const options = {
      method,
    };
    const response = yield call(request, updatedUrl, options);
    cb(response);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getTransactionCompleteTimeSaga() {
  yield takeEvery(GET_TRANSACTION_COMPLETE_TIME, getTransactionCompleteTime);
}

// Individual exports for testing
export default function* transactionTimeSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    setTransactionCompleteTimeSaga,
    getTransactionCompleteTimeSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
